import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, AlertTriangle, XCircle, Info, X } from 'lucide-react';
import { useToasts, toastApi, type ToastKind } from '@/hooks/useToast';
import { cn } from '@/lib/cn';

const palette: Record<ToastKind, string> = {
  ok:    'bg-emerald-600 text-white',
  warn:  'bg-amber-500 text-white',
  error: 'bg-red-600 text-white',
  info:  'bg-slate-800 text-white',
};

const icon = {
  ok:    <CheckCircle2 className="w-4 h-4" />,
  warn:  <AlertTriangle className="w-4 h-4" />,
  error: <XCircle className="w-4 h-4" />,
  info:  <Info className="w-4 h-4" />,
};

export function Toaster() {
  const items = useToasts();
  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
      <AnimatePresence>
        {items.map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: -8, x: 32 }}
            animate={{ opacity: 1, y: 0, x: 0 }}
            exit={{ opacity: 0, x: 32 }}
            transition={{ duration: 0.18 }}
            className={cn(
              'pointer-events-auto flex items-center gap-2.5 px-4 py-2.5 rounded-xl shadow-lg min-w-[220px] max-w-sm',
              palette[t.kind],
            )}
          >
            {icon[t.kind]}
            <span className="text-sm font-medium flex-1">{t.message}</span>
            <button
              onClick={() => toastApi.dismiss(t.id)}
              className="text-white/80 hover:text-white"
              aria-label="Dismiss"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
